import {FC, useEffect} from 'react'

import cn from 'classnames/bind'

import PortableBlocks from 'src/components/blocks/PortableBlocks'
import {Col, Container, Row} from 'src/components/elements/grid'
import {TermsAndConditionsPage} from 'src/types/__sanitySchema__'
import {klaviyoTrack} from 'src/utils'

import s from './TemplateTermsAndConditions.module.scss'

const cx = cn.bind(s)

interface ITemplateTermsAndConditionsProps {
	className?: string
	pageContent: TermsAndConditionsPage
}

const TemplateTermsAndConditions: FC<ITemplateTermsAndConditionsProps> = ({
	className,
	pageContent,
}) => {
	const {title, body} = pageContent

	useEffect(() => {
		klaviyoTrack('Page opened', {page: 'terms', href: window?.location?.href})
	}, [])

	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col xl={{offset: 1, span: 10}}>
						{title && <h2 className={cx('heading')}>{title}</h2>}
						<div className={cx('typography-page')}>
							{body && <PortableBlocks blockContent={body} />}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

TemplateTermsAndConditions.displayName = 'TemplateTermsAndConditions'

export default TemplateTermsAndConditions
